import { useState, useEffect } from "react";

/**
 * Dark mode hook with localStorage persistence
 * Uses browser localStorage API which is available in client-side React
 */
export function useDarkMode() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = window.localStorage.getItem("darkMode");
    if (saved !== null) {
      return JSON.parse(saved);
    }
    if (typeof window !== "undefined" && window.matchMedia) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    return false;
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (isDarkMode) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    window.localStorage.setItem("darkMode", JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode((prev) => !prev);

  return [isDarkMode, toggleDarkMode];
}
